import {
  Component, Inject, OnInit,
} from '@angular/core';

@Component({
  selector: 'ut-unified-email-verification-expired',
  templateUrl: './expired.component.html',
  standalone: false,
})
export class UnifiedEmailVerificationExpiredComponent implements OnInit {
  code: string | null = null;
  isResending = false;
  emailResent = false;
  error: string | null = null;
  static resendFailedMessage = 'Failed to resend email. Please try again.';
  constructor(
    @Inject('$state') private $state: any,
    @Inject('$window') private $window: any,
    @Inject('UserService') private UserService: any,
  ) { }

  ngOnInit(): void {
    // Extract email from URL parameters if available
    this.code = this.$state.params.emailCode || null;

    if (!this.code) {
      this.$state.go('setpassword-error');
    }

    // Check if user is already logged in
    this.UserService.me().then((res: any) => {
      if (res !== null) {
        this.$window.location.href = '/login';
      }
    }).catch(() => {
      this.$state.go('setpassword-error');
    });
  }

  resendEmail(): void {
    if (!this.code || this.isResending) {
      this.error = UnifiedEmailVerificationExpiredComponent.resendFailedMessage;
      return;
    }

    this.isResending = true;
    this.error = null;

    this.UserService.resendExpiredSetPasswordEmail(this.code)
      .then(() => {
        this.isResending = false;
        this.emailResent = true;
      })
      .catch(() => {
        this.isResending = false;
        this.error = UnifiedEmailVerificationExpiredComponent.resendFailedMessage;
      });
  }
}

export default UnifiedEmailVerificationExpiredComponent;
